<template>
  <form-wrapper>
    <form-group>
      <validation-provider v-slot="{errors}" name="phone" rules="required|min:11|max:19|phone">
        <text-input
          :label="$t('register.contact-phone')"
          :disabled="userDataIsValid"
          :errors="[...errors, ...backendErrors.phone]"
          mask="+0000000000000000000"
          :mask-options="{lazy:true}"
          required
          :value="formData.phone"
          @input="emitInput('phone', $event)"
        />
      </validation-provider>
      <validation-provider v-slot="{errors}" name="email" rules="required|reg_email">
        <text-input
          :label="$t('register.email')"
          :disabled="userDataIsValid"
          required
          :errors="[...errors, ...backendErrors.email]"
          :value="formData.email"
          @input="emitInput('email', $event)"
        />
      </validation-provider>
    </form-group>
    <template v-if="userDataIsValid">
      <form-group>
        <h3 class="register-step-password__big-hint">
          {{ $t('register.password-creation-hint') }}
        </h3>
        <validation-provider
          v-slot="{failedRules, dirty, invalid}"
          :bails="false"
          tag="div"
          class="register-step-password"
          rules="password|pw_length:8,20|pw_alpha|pw_numeric|pw_symbols"
        >
          <text-input
            :errors="[failedRules.password,...backendErrors.password1]"
            type="password"
            :label="$t('register.enter-password')"
            required
            :mask-options="{mask:/^\S+(?:\s\S+)*$/}"
            :force-hint="invalid && dirty"
            autocomplete="current-password"
            :value="formData.password1"
            @input="emitInput('password1', $event)"
          >
            <template #hint>
              <password-hint :failed-rules="failedRules" :dirty="dirty" />
            </template>
          </text-input>
        </validation-provider>
        <validation-provider v-slot="{errors}" tag="div" :rules="{pw_confirm: formData.password1}">
          <text-input
            :errors="[...errors]"
            type="password"
            :label="$t('register.re-enter-password')"
            :mask-options="{mask:/^\S+(?:\s\S+)*$/}"
            required
            autocomplete="current-password"
            :value="formData.password2"
            @input="emitInput('password2', $event)"
          />
        </validation-provider>
      </form-group>
      <form-group>
        <icu-select
          :options="sourceOptions"
          :value="formData.register_source"
          :get-option-value="opt => opt"
          :get-option-label="opt => $t(opt.name)"
          :label="$t('register.how-did-you-find-out')"
          multiple
          @input="emitInput('register_source', $event)"
        />
        <validation-provider
          v-if="showManualSourceInput"
          v-slot="{errors}"
          slim
          rules="register_source"
        >
          <text-input
            :errors="[...errors]"
            :value="registerSourceManual"
            :label="$t('register.your-option')"
            @input="emitRegisterSourceManual"
          />
        </validation-provider>
      </form-group>
    </template>
  </form-wrapper>
</template>

<script>
import TextInput from '@/components/inputs/TextInput.vue'
import FormWrapper from '@/components/views/RegisterPage/FormWrapper.vue'
import FormGroup from '@/components/views/RegisterPage/FormGroup.vue'
import {ValidationProvider} from 'vee-validate'
import PasswordHint from '@/components/misc/PasswordHint.vue'
import IcuSelect from '@/components/inputs/IcuSelect.vue'

export default {
  name: 'RegisterStep',
  components: { IcuSelect, PasswordHint, FormGroup, ValidationProvider, FormWrapper, TextInput },
  props: {
    formData: {
      type: Object,
      required: true
    },
    backendErrors: {
      type: Object,
      default: () => {}
    },
    registerSourceManual: {
      type: String,
      default: ''
    },
    userDataIsValid: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      sourceOptions: []
    }
  },
  computed: {
    showManualSourceInput() {
      return this.formData.register_source.find(source => source.id === 6)
    },
  },
  watch: {
    showManualSourceInput() {
      this.emitRegisterSourceManual('')
    },
  },
  mounted() {
    this.loadRegisterSourceOptions()
  },
  methods: {
    emitInput(formKey, value) {
      this.$emit('update-field', {formKey, value})
    },
    emitRegisterSourceManual(value) {
      this.$emit('update-register-source', value)
    },
    loadRegisterSourceOptions() {
      this.sourceOptions = [
        { id: 1, name: 'register.social-networks-option' },
        { id: 2, name: 'register.social-media-option' },
        { id: 3, name: 'Google' },
        { id: 4, name: 'Youtube' },
        { id: 5, name: 'register.from-friend-option' },
        { id: 6, name: 'register.your-option-option' },
      ]
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/theme.scss";

.register-step-password {
  display: grid;
  grid-row-gap: 5px;

  &__big-hint {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: -16px;
  }

  &-hints {
    margin-top: 5px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 2px;
    grid-column-gap: 12px;

    &__hint {
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      color: $gray-2;

      &.valid {
        color: $active-green;
      }

      &.invalid {
        color: $red;
      }
    }
  }
}
</style>
